/**
 * Custom JavaScript for theme functionality.
 *
 * Hooks available:
 * - variant:changed: Triggered when the product variant changes.
 *   document.addEventListener('variant:changed', function(event) {
 *     var variant = event.detail.variant;
 *   });
 * - product:added: Triggered when a product is added to the cart.
 *   document.addEventListener('product:added', function(event) {
 *     var variant = event.detail.variant;
 *     var quantity = event.detail.quantity;
 *   });
 * - cart:refresh: Triggered to refresh the mini-cart.
 *   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
 */

// Global Variables and Constants
const sortableMenu = document.querySelector('.sortable-menu');
let machineArray = [];
const currentSKU = $('#epProductSKU').text();
const machineList = $('#activeMachines');
let machinesLength = $('.machineListItem').length || 0;
const pageType = window.theme.pageType;
let activateSearch = false;
const assetPath = 'https://cdn.shopify.com/s/files/1/0363/9266/5221/t/59/assets/';
const plusIcon = "<svg class='icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' style='width:20px; height: 20px;'><path d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z'/></svg>";
const duplicateWarning = '<span class="ep-error"><svg viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c-4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/></svg>This machine has already been added, please try again</span>';
const serialWarning = '<span class="ep-error"><svg viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c-4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/></svg>Please Insert a Valid Serial Number</span>';
const machineMatchWarning = '<span class="ep-error"><svg viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c-4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/></svg>WARNING: This part/accessory is not compatible <br>with the selected machine.</span>';
const machineValidationWarning = '<span class="ep-warning"><svg viewBox="0 0 512 512"><path d="M504 256c0 137-111 248-248 248S8 393 8 256C8 119.1 119 8 256 8s248 111.1 248 248zm-248 50c-25.4 0-46 20.6-46 46s20.6 46 46 46 46-20.6 46-46-20.6-46-46-46zm-43.7-165.3l7.4 136c.3 6.4 5.6 11.3 12 11.3h48.5c6.4 0 11.6-5 12-11.3l7.4-136c.4-6.9-5.1-12.7-12-12.7h-63.4c-6.9 0-12.4 5.8-12 12.7z"/></svg> WARNING: There was an error with the validation. This part may not be compatible with the selected machine.</span>';
const successWarning = '<span class="ep-success"><svg viewBox="0 0 512 512"><path d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM227.3 387.3l184-184c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0L216 308.1l-70.1-70.1c-6.2-6.2-16.4-6.2-22.6 0l-22.6 22.6c6.2 6.2-6.2 16.4 0 22.6l104 104c6.2 6.2 16.4 6.2 22.6 0z"/></svg>Success! This item is compatible <br>with the selected machine.</span>';

// Early redirect check for search pages - run immediately before DOM loads
(function earlySearchRedirect() {
    if (pageType === 'search' && localStorage.getItem('EP-Machines')) {
        try {
            const storedMachines = JSON.parse(localStorage.getItem('EP-Machines'));
            if (storedMachines && storedMachines.length > 0) {
                // Get the active machine (last in array)
                const activeMachine = storedMachines[storedMachines.length - 1];
                const serviceListTag = activeMachine.serviceListName.replace(/[^\w\s]|_/g, "").replace(/\s+/g, '-');

                // Get search query from URL
                const urlParams = new URLSearchParams(window.location.search);
                const searchQuery = urlParams.get('q') || '';

                // Redirect immediately
                if (searchQuery) {
                    console.log('Early redirect: Search page with active machine detected, redirecting with query:', searchQuery);
                    window.location.href = `/collections/${serviceListTag}?sort_by=title-ascending&q=${encodeURIComponent(searchQuery)}`;
                } else {
                    console.log('Early redirect: Search page with active machine detected, redirecting without query');
                    window.location.href = `/collections/${serviceListTag}?sort_by=title-ascending`;
                }
            }
        } catch (error) {
            console.error('Error in early search redirect:', error.message);
        }
    }
})();

// Utility Functions
function enableCartButton(message) {
    $('#buttonWarning .product-form__add-button').removeAttr('disabled');
    $('.product-form__payment-container').removeClass('serialDisabled');
    $('.serialMessage').removeClass('inactiveSerial');
    $('.serialWarning').html(message).fadeIn();
}

function disableCartButton(message) {
    $('#buttonWarning .product-form__add-button').attr("disabled", "disabled");
    $('.product-form__payment-container').addClass('serialDisabled');
    $('.serialMessage').addClass('inactiveSerial');
    $('.serialWarning').html(message).fadeIn();
}

function moveElement(array, fromIndex, toIndex) {
    const element = array.splice(fromIndex, 1)[0];
    array.splice(toIndex, 0, element);
    return array;
}

function setToStorage() {
    localStorage.setItem('EP-Machines', JSON.stringify(machineArray));
}

// Serial Number Validation Functions
function addMachine(data, index, shouldRedirect = false) {
    const marketingName = data.marketingName;
    const marketingURL = marketingName.replace(/\s+/g, '-').toLowerCase();
    $('.machineListItem').removeClass('activeMachineListItem');

    const machineCodeBlock =
        `<div id="${index}" class="machAnimate activeMachineListItem machineListItem">
      <div class="machineListHeader">
        <div><div class="active">Active</div>
        <div class="activateThisMachine link">Activate</div></div>
        <div class="removeThisMachine link">Remove</div>
      </div>
      <div class="mini-cart__line-item">
        <div class="mini-cart__image-wrapper">
          <img src="${assetPath}${marketingURL}_icon.jpg" alt="${marketingName}">
        </div>
        <div class="mini-cart__item-wrapper">
          <div class="mini-cart__product-info">
            <h3 class="heading text--strong ep-margin-remove-bottom">${marketingName}</h3>
            <span class="machineListWattage">${data.wattage}</span>
            <div><span class="machineListSerial"><span class="heading">Serial: </span>${data.serialNumber}</span></div>
          </div>
        </div>
        <div class="draggable-icon"></div>
      </div>
    </div>`;

    machineList.prepend(machineCodeBlock);
    if (machinesLength > 1) {
        machineList.children('.machineListItem:not(.activeMachineListItem)').addClass('sort');
    }
    machinesLength++;

    $('.machine-img').css("background-image", `url(${assetPath}${marketingURL}_icon.jpg)`);
    $('#validation-icon .machine-img').addClass('icon-bounce');
    $('.machine-name').html(marketingName);
    $('.machine-serial').html(data.serialNumber);
    $('.MachineDesc').addClass('textReveal');

    setTimeout(() => {
        $('.machAnimate').addClass('machineReveal');
        $('.machineSerialInput label').html('Want to use a Different Serial Number?').fadeIn(500);
        $('#validation-icon .machine-img').removeClass('icon-bounce');
    }, 0);

    // If we're on a collection page and should redirect, navigate to the new machine's collection
    if (shouldRedirect && pageType === 'collection') {
        console.log('New machine added on collection page, redirecting to its collection');
        setTimeout(() => {
            const adjMachinesLength = machinesLength - 1 || 0;
            activeMachineSearch(adjMachinesLength);
        }, 500);
    }
}

// Function to check if the page is a Machine product page
function isMachineProductPage() {
    const productType = window.theme.product && window.theme.product.type;
    return productType === 'Machine';
}

function checkCompatibility(index) {
    if (pageType === 'product' && !isMachineProductPage()) {
        if ($.inArray(currentSKU, machineArray[index].items) !== -1) {
            enableCartButton(successWarning);
            $('#active-serial-number-input').val(machineArray[index].serialNumber);
        } else {
            disableCartButton(machineMatchWarning);
            $('#active-serial-number-input').val('');
        }
    }
}

function activeMachineSearch(index) {
    const serviceListTag = machineArray[index].serviceListName.replace(/[^\w\s]|_/g, "").replace(/\s+/g, '-');

    if (pageType === 'search') {
        // If on search page, redirect to the machine's collection with the search query
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get('q') || '';
        if (searchQuery) {
            console.log('Redirecting from search to collection with query:', searchQuery);
            location.href = `/collections/${serviceListTag}?sort_by=title-ascending&q=${encodeURIComponent(searchQuery)}`;
        } else {
            console.log('Redirecting from search to collection (no query)');
            location.href = `/collections/${serviceListTag}?sort_by=title-ascending`;
        }
    } else {
        // On collection page, just redirect to the new collection
        location.href = `/collections/${serviceListTag}?sort_by=title-ascending`;
    }
}

function activateMachine() {
    $('#machinePanel').on('click', '.activateThisMachine', function () {
        const thisMachine = $(this).closest('.machineListItem');
        const newID = thisMachine.attr('id');
        const activeMarketingName = machineArray[newID].marketingName;
        const newURL = activeMarketingName.replace(/\s+/g, '-').toLowerCase();
        checkCompatibility(newID);
        if ($('.machineListItem').length > 1) {
            $('.activeMachineListItem').addClass('sort');
        }
        $('.activeMachineListItem').removeClass('activeMachineListItem');
        thisMachine.addClass('activeMachineListItem').removeClass('sort');
        $('#activeMachines').prepend(thisMachine);
        $('.machine-img').css("background-image", `url(${assetPath}${newURL}_icon.jpg)`);
        $('.machine-name').html(activeMarketingName);
        $('.machine-serial').html(machineArray[newID].serialNumber);
        machineArray.push(machineArray.splice(newID, 1)[0]);

        $('.machineListItem').each(function (index) {
            $(this).attr('id', machinesLength - index - 1 || 0);
        });

        setTimeout(() => {
            setToStorage();
        }, 0);

        // If on collection or search page, automatically redirect to filtered collection
        if (pageType === 'collection' || pageType === 'search') {
            console.log('Machine activated on collection/search page, auto-filtering');
            setTimeout(() => {
                const adjMachinesLength = machinesLength - 1 || 0;
                activeMachineSearch(adjMachinesLength);
            }, 100);
        }
    });
}

function removeMachines() {
    localStorage.clear();
    machineArray = [];
    $(".serialWarning").fadeOut();
    $('#validation-icon .machine-img').css("background-image", "url('https://cdn.shopify.com/s/files/1/0363/9266/5221/t/59/assets/default-machine_icon.jpg')");
    $('.MachineDesc').removeClass('textReveal');
    $('.machAnimate').removeClass('machineReveal');
    $('.machineSerialInput label').html('Laser Machine Serial Number<span class="ep-red">*</span>: (Required)').fadeIn(500);
    $('.product-form__payment-container').addClass('serialDisabled');
    machinesLength = 0;

    setTimeout(() => {
        machineList.empty();
        $('.machine-name').html(plusIcon);
        $('.machine-serial').html('');
    }, 400);
}

function removeMachine() {
    $('#machinePanel').on('click', '.removeThisMachine', function () {
        if ($('.machineListItem').length > 1) {
            const thisMachine = $(this).closest('.machineListItem');
            const thisID = thisMachine.attr('id');
            const wasActiveMachine = thisMachine.hasClass('activeMachineListItem');
            machinesLength--;

            if (wasActiveMachine) {
                const newItem = $('.machineListItem').next();
                const nextID = newItem.attr('id');
                const activeMarketingName = machineArray[nextID].marketingName;
                const newURL = activeMarketingName.replace(/\s+/g, '-').toLowerCase();
                checkCompatibility(nextID);
                $(`#${nextID}`).addClass('activeMachineListItem');
                $('.machine-img').css("background-image", `url(${assetPath}${newURL}_icon.jpg)`);
                $('.machine-name').html(activeMarketingName);
                $('.machine-serial').html(machineArray[nextID].serialNumber);
            }

            if ($('.machineListItem').length < 4) {
                $('.machineListItem').removeClass('sort');
            }

            thisMachine.removeClass('machineReveal');
            machineArray.splice(thisID, 1);

            setTimeout(() => {
                setToStorage();
            }, 0);

            setTimeout(() => {
                thisMachine.remove();
                $('.machineListItem').each(function (index) {
                    $(this).attr('id', machinesLength - index - 1 || 0);
                });

                // If we removed the active machine on a collection or search page, redirect to the new active machine
                if (wasActiveMachine && (pageType === 'collection' || pageType === 'search')) {
                    console.log('Active machine removed on collection/search page, redirecting to next machine');
                    setTimeout(() => {
                        const adjMachinesLength = machinesLength - 1 || 0;
                        activeMachineSearch(adjMachinesLength);
                    }, 200);
                }
            }, 400);
        } else {
            removeMachines();
        }
    });
}

function checkStorage() {
    if ('EP-Machines' in localStorage) {
        machineArray = JSON.parse(localStorage.getItem('EP-Machines'));
        // Pass false for shouldRedirect when loading from storage
        machineArray.forEach((machine, index) => addMachine(machine, index, false));
        setTimeout(() => {
            const adjMachinesLength = machinesLength - 1 || 0;
            checkCompatibility(adjMachinesLength);
        }, 0);
    }
}

// Check URL for serial number parameter and auto-populate/filter
async function checkURLForSerial() {
    const urlParams = new URLSearchParams(window.location.search);
    const serialNumber = urlParams.get('serialNumber');

    if (serialNumber && pageType === 'collection') {
        console.log('Serial number detected in URL:', serialNumber);

        // Populate the serial input field
        $('.serial-input').val(serialNumber);

        // Check if this serial is already in storage
        const existingMachineIndex = machineArray.findIndex(item => item.serialNumber === serialNumber);

        if (existingMachineIndex !== -1) {
            console.log('Machine already exists in storage');

            // Check if this machine is already active (first in array)
            if (existingMachineIndex === machinesLength - 1) {
                console.log('Machine is already active, checking collection match');

                // Verify we're on the correct collection for this machine
                const currentPath = window.location.pathname;
                const expectedCollection = machineArray[existingMachineIndex].serviceListName.replace(/[^\w\s]|_/g, "").replace(/\s+/g, '-');

                if (!currentPath.includes(expectedCollection)) {
                    console.log('Wrong collection page, redirecting to correct one');
                    activeMachineSearch(existingMachineIndex);
                } else {
                    console.log('Already on correct collection page, no action needed');
                }
            } else {
                console.log('Machine exists but not active, activating and redirecting');
                // Make this machine active by moving it to the front of the array
                machineArray.push(machineArray.splice(existingMachineIndex, 1)[0]);

                // Update the UI
                const machineToActivate = $(`.machineListItem[id="${existingMachineIndex}"]`);
                $('.machineListItem').removeClass('activeMachineListItem').addClass('sort');
                machineToActivate.addClass('activeMachineListItem').removeClass('sort');
                $('#activeMachines').prepend(machineToActivate);

                const activeMarketingName = machineArray[machinesLength - 1].marketingName;
                const newURL = activeMarketingName.replace(/\s+/g, '-').toLowerCase();
                $('.machine-img').css("background-image", `url(${assetPath}${newURL}_icon.jpg)`);
                $('.machine-name').html(activeMarketingName);
                $('.machine-serial').html(machineArray[machinesLength - 1].serialNumber);

                // Update IDs
                $('.machineListItem').each(function (index) {
                    $(this).attr('id', machinesLength - index - 1 || 0);
                });

                setToStorage();

                // Redirect to the correct collection
                setTimeout(() => {
                    const adjMachinesLength = machinesLength - 1 || 0;
                    activeMachineSearch(adjMachinesLength);
                }, 100);
            }
        } else {
            console.log('New machine from URL, validating without redirect');
            // Validate the serial and add to storage, but don't redirect since we're already on a collection page
            try {
                $('#ep-spinner').addClass('active');
                const response = await fetch(`https://epilogportalapi-a0hbcud5bjdbdmay.eastus-01.azurewebsites.net/api/EpilogPortalAPI/GetSerialDetails/${serialNumber}/bxiFmd3r9SQQGNQGHjyP`, {
                    headers: { 'Content-Type': 'text/plain' },
                    method: "GET"
                });

                if (response.ok) {
                    const data = await response.json();
                    $('#ep-spinner').removeClass('active');

                    if (data.errorMessage === 'Invalid Serial Number.' || data.errorMessage === 'Unable to verify serial number.') {
                        console.log('Invalid serial number in URL');
                    } else {
                        // Add machine without redirect (we're already on the collection page)
                        machineArray.push(data);
                        addMachine(data, machinesLength, false);
                        setToStorage();

                        // Show warranty popup if applicable, but don't redirect
                        if (data.inWarranty) {
                            toggleWarrantyPopup();
                        }

                        setTimeout(() => {
                            const adjMachinesLength = machinesLength - 1 || 0;
                            checkCompatibility(adjMachinesLength);
                        }, 0);
                    }
                } else {
                    $('#ep-spinner').removeClass('active');
                    console.log('Error validating serial from URL');
                }
            } catch (error) {
                console.error('Error in checkURLForSerial:', error.message);
                $('#ep-spinner').removeClass('active');
            }
        }
    }
}

// Check if we're on the parts landing page
function isOnPartsLandingPage() {
    const currentPath = window.location.pathname;
    return currentPath.includes('/collections/parts-and-accessories') && pageType === 'collection';
}

// Auto-redirect from parts landing page to active machine collection
function checkPartsLandingPageRedirect() {
    if (isOnPartsLandingPage() && machineArray.length > 0) {
        console.log('Parts landing page detected with active machine, auto-redirecting');
        // Get the active machine (first in array)
        const adjMachinesLength = machinesLength - 1 || 0;
        activeMachineSearch(adjMachinesLength);
    }
}

function toggleWarrantyPopup() {
    $("#machineSelectorWrapper.ep-popup").fadeOut();
    $("#warrantyPopupWrapper.ep-popup").fadeIn();
}

async function validateSerial() {
    $('.serial-input').on('click', function () {
        $(".serialWarning").fadeOut();
    });
    $('.serial-button').on("click", async function () {
        const serialNumber = $(this).closest('.serial-wrapper').find('.serial-input').val();
        const len = serialNumber.length;

        if (len > 11 && len < 21) {
            const result = machineArray.find(item => item.serialNumber === serialNumber);
            if (result) {
                disableCartButton(duplicateWarning);
            } else {
                try {
                    $('#ep-spinner').addClass('active');
                    const response = await fetch(`https://epilogportalapi-a0hbcud5bjdbdmay.eastus-01.azurewebsites.net/api/EpilogPortalAPI/GetSerialDetails/${serialNumber}/bxiFmd3r9SQQGNQGHjyP`, {
                        headers: { 'Content-Type': 'text/plain' },
                        method: "GET"
                    });

                    if (response.ok) {
                        const data = await response.json();
                        $('#ep-spinner').removeClass('active');

                        if (data.errorMessage === 'Invalid Serial Number.') {
                            disableCartButton(serialWarning);
                        } else if (data.errorMessage === 'Unable to verify serial number.') {
                            enableCartButton(machineValidationWarning);
                        } else {
                            $('.serial-input').val("");
                            machineArray.push(data);

                            const filterRedirect = $(this).hasClass('filter-serial-button');
                            const isHeaderInput = !filterRedirect && pageType === 'collection' && machinesLength === 0;

                            // Pass shouldRedirect=true if adding FIRST machine from header on collection page
                            addMachine(data, machinesLength, isHeaderInput);
                            setToStorage();

                            // Handle warranty popup and redirects
                            if (isHeaderInput) {
                                // First machine from header - redirect is handled by addMachine, skip warranty popup
                            } else if (data.inWarranty && filterRedirect) {
                                // Filter button with warranty - show popup first, then redirect after closing
                                toggleWarrantyPopup();
                                activateSearch = true;
                            } else if (data.inWarranty && !filterRedirect && pageType === 'collection') {
                                // Header input (2nd+ machine) with warranty on collection page - show popup, then redirect
                                toggleWarrantyPopup();
                                activateSearch = true;
                            } else if (data.inWarranty) {
                                // Other pages with warranty - just show popup
                                toggleWarrantyPopup();
                            } else if (filterRedirect) {
                                // Filter button without warranty - redirect immediately
                                const adjMachinesLength = machinesLength - 1 || 0;
                                activeMachineSearch(adjMachinesLength);
                            } else if (!filterRedirect && pageType === 'collection') {
                                // Header input (2nd+ machine) without warranty on collection page - redirect immediately
                                setTimeout(() => {
                                    const adjMachinesLength = machinesLength - 1 || 0;
                                    activeMachineSearch(adjMachinesLength);
                                }, 500);
                            }

                            setTimeout(() => {
                                const adjMachinesLength = machinesLength - 1 || 0;
                                checkCompatibility(adjMachinesLength);
                            }, 0);
                        }
                    } else {
                        $('#ep-spinner').removeClass('active');
                        enableCartButton(machineValidationWarning);
                    }
                } catch (error) {
                    console.error('Error in validateSerial:', error.message);
                    $('#ep-spinner').removeClass('active');
                    disableCartButton(serialWarning);
                }
            }
        } else {
            disableCartButton(serialWarning);
        }
    });
}

function initializeSerialValidation() {
    checkStorage();
    checkURLForSerial(); // Check URL for serial number parameter
    checkPartsLandingPageRedirect(); // Auto-redirect from parts landing page
    // Note: Search page redirect happens early via IIFE above, before DOM ready
    validateSerial();
    activateMachine();
    removeMachine();

    $('.removeMachines').on('click', removeMachines);
    $('.machineToggle').on('click', () => $("#machineSelectorWrapper.ep-popup").fadeIn());

    $('.ep-tabs-list-item').click(function () {
        const tab_id = $(this).attr('data-tab');
        $('.ep-active').removeClass('ep-active');
        $('.ep-tab-content').removeClass('ep-current');
        $(this).addClass('ep-active');
        $(`#${tab_id}`).addClass('ep-current');
    });

    $("#machineSelectorWrapper.ep-popup, #machineSelectorWrapper .closePopup").on("click", () => $(".ep-popup").fadeOut());
    $("#warrantyPopupWrapper.ep-popup, #warrantyPopupWrapper .closePopup").on("click", () => {
        $("#warrantyPopupWrapper.ep-popup").fadeOut();
        if (activateSearch) {
            const adjMachinesLength = machinesLength - 1 || 0;
            activeMachineSearch(adjMachinesLength);
        }
    });
    $("#warrantyPopup, #machineSelector").on("click", event => event.stopPropagation());
}

// Cost Table Functions
function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        const moneyFormat = document.querySelector('.cost-table')?.dataset.moneyFormat || '${{amount}}';
        return Shopify.formatMoney(cents, moneyFormat);
    }
    const moneyFormat = document.querySelector('.cost-table')?.dataset.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount.replace(/\d(?=(\d{3})+\.)/g, '$&,'));
}

function calculateAccessoryTotal() {
    let accessoryTotal = 0;
    const cards = document.querySelectorAll('lb-upsell-flat-card');

    cards.forEach(card => {
        try {
            const priceElement = card.querySelector('span[lb-price]');
            const priceText = priceElement?.getAttribute('lb-price') || '0';
            const price = parseFloat(priceText.replace(/[^0-9.]/g, '')) * 100 || 0;

            const checkbox = card.querySelector('.lb-card-checkbox[type="checkbox"]');
            const hasCheckedClass = !!card.querySelector('.lb-custom-checkbox.lb-checked');
            const isSelected = checkbox && checkbox.checked && hasCheckedClass;

            const flatCard = card.querySelector('.lb-flat-card');
            if (flatCard) {
                if (isSelected) {
                    flatCard.classList.add('ep-card-active', 'active');
                } else {
                    flatCard.classList.remove('ep-card-active', 'active');
                }
            }

            const quantity = isSelected ? 1 : 0;
            accessoryTotal += price * quantity;
        } catch (e) {
            console.error('Error processing card:', e.message);
        }
    });

    return accessoryTotal;
}

function updateCostTable() {
    try {
        const variantSelect = document.querySelector('select[name="id"]');
        const selectedVariantId = variantSelect ? variantSelect.value : null;
        let variantPrice = parseFloat(document.querySelector('.cost-table')?.dataset.initialPrice || 0);

        if (selectedVariantId && window.ShopifyCostTable && window.ShopifyCostTable.variantPrices[selectedVariantId]) {
            variantPrice = window.ShopifyCostTable.variantPrices[selectedVariantId];
        }

        const quantityInput = document.querySelector('input[name="quantity"]');
        const productQuantity = quantityInput && !isNaN(parseInt(quantityInput.value)) ? parseInt(quantityInput.value) : 1;

        const machineCost = variantPrice * productQuantity;
        const accessoryTotal = calculateAccessoryTotal();
        const totalCost = machineCost + accessoryTotal;

        const productCost = document.getElementById('product-cost');
        const accessoryCost = document.getElementById('accessory-total');
        const totalCostEl = document.getElementById('total-cost');

        if (productCost) productCost.innerText = formatMoney(machineCost);
        if (accessoryCost) accessoryCost.innerText = formatMoney(accessoryTotal);
        if (totalCostEl) totalCostEl.innerText = formatMoney(totalCost);
    } catch (e) {
        console.error('Error in updateCostTable:', e.message);
    }
}

function setupEventListeners() {
    document.addEventListener('click', event => {
        try {
            const target = event.target.closest('.lb-card-checkbox, lb-upsell-flat-card, .lb-cta-cont');
            if (target) {
                const form = target.closest('form[action*="/cart/add"]');
                if (form) {
                    const formData = Array.from(new FormData(form).entries());
                    formData.forEach(([key, value]) => {
                        if (key.includes('addon') || key.includes('properties')) {
                            console.log('Addon detected:', key, value);
                        }
                    });
                }
                setTimeout(updateCostTable, 500);
            }
        } catch (e) {
            console.error('Error in click listener:', e.message);
        }
    }, { capture: true });

    document.addEventListener('click', event => {
        try {
            const cartButton = event.target.closest('button[name="add"], button[type="submit"][form*="/cart/add"]');
            if (cartButton) {
                const form = cartButton.closest('form[action*="/cart/add"]');
                if (form) {
                    const formData = Array.from(new FormData(form).entries());
                    formData.forEach(([key, value]) => {
                        if (key.includes('addon') || key.includes('properties')) {
                            console.log('Addon detected:', key, value);
                        }
                    });
                }
                setTimeout(updateCostTable, 500);
            }
        } catch (e) {
            console.error('Error in cart button listener:', e.message);
        }
    });

    document.addEventListener('submit', event => {
        try {
            if (event.target.matches('form[action*="/cart/add"]')) {
                const formData = Array.from(new FormData(event.target).entries());
                formData.forEach(([key, value]) => {
                    if (key.includes('addon') || key.includes('properties')) {
                        console.log('Addon detected:', key, value);
                    }
                });
                setTimeout(updateCostTable, 500);
            }
        } catch (e) {
            console.error('Error in submit listener:', e.message);
        }
    });

    document.addEventListener('change', event => {
        try {
            if (event.target.matches('select[name="id"], input[name="quantity"]')) {
                updateCostTable();
            }
        } catch (e) {
            console.error('Error in change listener:', e.message);
        }
    });
}

function handleSelectionToggle(event) {
    const target = event.target;

    // Skip if clicking lb-card-title or its descendants
    if (target.closest('.lb-card-title, .lb-card-title-cont')) {
        return;
    }

    const card = target.closest('.lb-flat-card');
    const checkbox = target.closest('.lb-card-checkbox') || (card && card.querySelector('.lb-card-checkbox'));
    const plusIcon = target.closest('.epPlusIcon');

    if (!checkbox) {
        return; // Exit if no checkbox found
    }

    // Toggle checkbox state for card or plus icon clicks
    if (card && (plusIcon || !target.matches('.lb-card-checkbox'))) {
        checkbox.checked = !checkbox.checked;
    }

    const flatCard = checkbox.closest('.lb-flat-card');
    const customCheckbox = checkbox.parentElement.querySelector('.lb-custom-checkbox');

    // Sync classes based on checkbox state
    if (checkbox.checked) {
        flatCard.classList.add('active', 'ep-card-active');
        customCheckbox.classList.add('lb-checked');
    } else {
        flatCard.classList.remove('active', 'ep-card-active');
        customCheckbox.classList.remove('lb-checked');
    }

    // Force reflow for CSS transition
    flatCard.offsetHeight;

    // Dispatch change event
    const changeEvent = new Event('change', { bubbles: true });
    checkbox.dispatchEvent(changeEvent);

    // Update cost table
    setTimeout(updateCostTable, 0);

    console.log('Selection toggled, checkbox state:', checkbox.checked, 'Card classes:', flatCard.className);
}

function initializeCheckBoxAnimation() {
    console.log('Running initializeCheckBoxAnimation');
    try {
        const checkboxes = document.querySelectorAll('.lb-card-checkbox:not([data-initialized="true"])');
        checkboxes.forEach(checkbox => {
            const container = checkbox.closest('.lb-checkbox-cont');
            const card = checkbox.closest('.lb-flat-card');

            checkbox.style.width = '';
            checkbox.style.height = '';
            checkbox.style.margin = '';
            checkbox.style.padding = '';

            const checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            checkSvg.setAttribute('viewBox', '0 0 21 21');
            checkSvg.classList.add('epCheckBox');
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', 'M5,10.8l3.5,3.5,9.1-10.1c-3.3-3.5-7.1-3.1-7.1-3.1C4.3,1,1,6.3,1,10.5s3.2,9.5,9.5,9.5,9.5-5.7,9.5-9.5');
            checkSvg.appendChild(path);
            checkbox.insertAdjacentElement('afterend', checkSvg);

            const plusSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            plusSvg.setAttribute('viewBox', '0 0 512 512');
            plusSvg.classList.add('epPlusIcon');
            plusSvg.innerHTML = '<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"/>';
            checkSvg.insertAdjacentElement('afterend', plusSvg);

            const customCheckbox = container.querySelector('.lb-custom-checkbox');
            if (customCheckbox) {
                customCheckbox.style.width = '';
                customCheckbox.style.height = '';
                customCheckbox.style.margin = '';
                customCheckbox.style.padding = '';
            }

            container.classList.add('path', 'bounce');

            if (checkbox.checked) {
                card.classList.add('active', 'ep-card-active');
                customCheckbox.classList.add('lb-checked');
            }

            checkbox.dataset.initialized = 'true';
        });

        checkboxes.forEach(checkbox => {
            // Remove existing listeners to prevent duplicates
            checkbox.removeEventListener('click', handleSelectionToggle);
            checkbox.addEventListener('click', handleSelectionToggle);

            const card = checkbox.closest('.lb-flat-card');
            if (card) {
                card.removeEventListener('click', handleSelectionToggle);
                card.addEventListener('click', handleSelectionToggle);
            }

            const plusIcon = checkbox.parentElement.querySelector('.epPlusIcon');
            if (plusIcon) {
                plusIcon.removeEventListener('click', handleSelectionToggle);
                plusIcon.addEventListener('click', handleSelectionToggle);
            }
        });
    } catch (e) {
        console.error('Error in initializeCheckBoxAnimation:', e.message, e.stack);
    }
}

function initializeWidgetObserver(maxRetries = 120, interval = 500) {
    let retries = 0;
    console.log('Starting widget observer');
    const widgetInterval = setInterval(() => {
        try {
            const widget = document.querySelector('.lb-upsell-widget, [class*="lb-widget"], [class*="upsell-widget"]');
            const cards = document.querySelectorAll('lb-upsell-flat-card');
            console.log('Checking widget:', !!widget, 'Cards:', cards.length);

            if (widget && cards.length > 0 && isMachineProductPage()) {
                clearInterval(widgetInterval);
                $('#ep-spinner').removeClass('active');
                const costTable = document.querySelector('.cost-table');
                if (costTable) costTable.style.display = 'block';

                initializeCheckBoxAnimation();

                const costObserver = new MutationObserver(mutations => {
                    if (mutations.some(m => m.addedNodes.length || m.removedNodes.length || m.attributeName)) {
                        console.log('Widget mutation detected, updating cost table');
                        setTimeout(updateCostTable, 500);
                    }
                });
                costObserver.observe(widget, { childList: true, subtree: true, attributes: true });

                const checkboxObserver = new MutationObserver(mutations => {
                    const newCheckboxes = mutations.some(m =>
                        Array.from(m.addedNodes).some(node =>
                            node.nodeType === 1 && (node.matches('.lb-card-checkbox') || node.querySelector('.lb-card-checkbox'))
                        )
                    );
                    if (newCheckboxes) {
                        console.log('New checkboxes detected, initializing animation');
                        setTimeout(initializeCheckBoxAnimation, 500);
                    }
                });
                checkboxObserver.observe(document.body, { childList: true, subtree: true });

                updateCostTable();
            } else if (retries >= maxRetries) {
                console.warn('Selleasy widget or cards not found after', maxRetries, 'retries');
                clearInterval(widgetInterval);
                if (isMachineProductPage()) {
                    $('#ep-spinner').removeClass('active');
                    const costTable = document.querySelector('.cost-table');
                    if (costTable) costTable.style.display = 'block';
                }
            } else {
                retries++;
            }
        } catch (e) {
            console.error('Error in widget observer:', e.message, e.stack);
        }
    }, interval);

    setTimeout(() => {
        if (isMachineProductPage()) {
            $('#ep-spinner').removeClass('active');
            const costTable = document.querySelector('.cost-table');
            if (costTable) costTable.style.display = 'block';
        }
    }, 10000);
}

function initializeCostTable() {
    setupEventListeners();
    if (isMachineProductPage()) {
        $('#ep-spinner').addClass('active');
        initializeWidgetObserver();
    }
    initializeCheckBoxAnimation();
}

// Sortable Menu Setup
const sortable = new Draggable.Sortable(document.querySelectorAll('.sortable'), {
    draggable: '.sort',
    handle: '.draggable-icon',
    delay: 0,
    mirror: {
        xAxis: false,
        appendTo: 'body',
        constrainDimensions: true
    },
    swapAnimation: {
        duration: 300,
        easingFunction: 'ease-in-out',
        horizontal: false
    },
    plugins: [Draggable.Plugins.SwapAnimation]
});

sortable.on('sortable:stop', e => {
    moveElement(machineArray, e.newIndex, e.oldIndex);
    setTimeout(() => {
        $('.machineListItem').each(function (index) {
            $(this).attr('id', machinesLength - index - 1 || 0);
        });
    }, 0);
    setTimeout(() => {
        setToStorage();
    }, 200);
});

// Initialize on DOM ready
$(document).ready(function () {
    initializeSerialValidation();
    if ($('.ep-addons').length && isMachineProductPage()) {
        initializeCostTable();
    }
});